import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IExhibitorDevicesPayloadState } from '@app-store/slices/companyStatistics/exhibitorDevices'

interface TaskAction extends Action {
    payload: IExhibitorDevicesPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.companyStatistics.exhibitorDevices

function* exhibitorDevicesSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/stats/exhibitor/devices`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* exhibitorDevicesSaga(): any {
    yield takeLatest<TaskAction>(onRequest, exhibitorDevicesSagaTask)
}

export default exhibitorDevicesSaga
